import {
  CHANGE_LOCALE,
  CHANGE_PROPERTY,
  CHANGE_DOMAINS,
  CHANGE_TIMEZONE,
  CHANGE_CURRENCY,
  CHANGE_USER,
  CHANGE_USER_NAME,
  CHECK_VOUCHER_ENGINE,
  CHANGE_GROUP,
  CHECK_SALESFORCE,
  CHANGE_CLODBEDS,
  CHANGE_GROUP_LOGO,
  CHANGE_TABS,
  CHANGE_INSTAGRAM,
  CHANGE_SERVICE_PROVIDER,
  CHANGE_GROUP_BILLING_CURRENCY,
  CHANGE_PROPERTY_PROVIDER,
  CHANGE_PROPERTY_TAGS,
  CHANGE_CURRENT_INTEGRATION_TAB
} from '../actions';

export const changeCurrentIntegrationTab = (val) => {
  localStorage.setItem('currentIntegrationTab', val);
  return {
    type: CHANGE_CURRENT_INTEGRATION_TAB,
    payload: val,
  };
};

export const changePropertyTags = (val) => {
  console.log('action property tags', val, 22);
  localStorage.setItem('propertyTags', val);
  return {
    type: CHANGE_PROPERTY_TAGS,
    payload: val,
  };
};

export const changePropertyProvider = (val) => {
  return {
    type: CHANGE_PROPERTY_PROVIDER,
    payload: val,
  };
};

export const changeInstagram = (val) => {
  localStorage.setItem('instagramId', val);
  return {
    type: CHANGE_INSTAGRAM,
    payload: val,
  };
};

export const changeServiceProvider = (val) => {
  localStorage.setItem('service_provider', val);
  return {
    type: CHANGE_SERVICE_PROVIDER,
    payload: val,
  };
};

export const changeLocale = (locale) => {
  localStorage.setItem('currentLanguage', locale);
  return {
    type: CHANGE_LOCALE,
    payload: locale,
  };
};

export const changeTabs = (tab) => {
  localStorage.setItem('integrationTab', tab);
  return {
    type: CHANGE_TABS,
    payload: tab,
  };
};

export const changeProperty = (propertyId) => {
  localStorage.setItem('currentPropertyId', propertyId);
  return {
    type: CHANGE_PROPERTY,
    payload: propertyId,
  };
};

export const changeDomains = (domains) => {
  localStorage.setItem('currentDomains', domains);
  return {
    type: CHANGE_DOMAINS,
    payload: domains,
  };
};

export const changeTimeZone = (timeZone) => {
  localStorage.setItem('timeZone', timeZone);
  return {
    type: CHANGE_TIMEZONE,
    payload: timeZone,
  };
};

export const changeCurrency = (currency) => {
  localStorage.setItem('currency', currency);
  return {
    type: CHANGE_CURRENCY,
    payload: currency,
  };
};

export const changeGroupBillingCurrency = (currency) => {
  localStorage.setItem('group_billing_currency', currency);
  return {
    type: CHANGE_GROUP_BILLING_CURRENCY,
    payload: currency,
  };
};

export const changeUser = (email) => {
  localStorage.setItem('email', email);
  return {
    type: CHANGE_USER,
    payload: email,
  };
};

export const changeUserName = (userName) => {
  localStorage.setItem('userName', userName);
  return {
    type: CHANGE_USER_NAME,
    payload: userName,
  };
};

export const changeServiceProviderLogo = (val) => {
  localStorage.setItem('service_provider_logo', val);
  return {
    type: CHANGE_GROUP_LOGO,
    payload: val,
  };
};

export const CheckVoucherEngine = (val) => {
  localStorage.setItem('isVoucherEngine', val);
  return {
    type: CHECK_VOUCHER_ENGINE,
    payload: val,
  };
};

export const ChangeGroupId = (val) => {
  localStorage.setItem('groupId', val);
  return {
    type: CHANGE_GROUP,
    payload: val,
  };
};
export const changeSalesforceId = (val) => {
  localStorage.setItem('salesforceId', val);
  return {
    type: CHECK_SALESFORCE,
    payload: val,
  };
};

export const Changecloudbeds = (val) => {
  localStorage.setItem('cloudbedsId', val);
  return {
    type: CHANGE_CLODBEDS,
    payload: val,
  };
};
